import httpService from '@/services/httpService'

export const types = {
  ADD_CLIENT_NOTES: 'client-note/ADD_CLIENT_NOTES',
  ADD_CLIENT_NOTE_OPTIONS: 'client-note/ADD_CLIENT_NOTE_OPTIONS',
  ADD_CLIENT_NOTE_SETTINGS: 'client-note/ADD_CLIENT_NOTE_SETTINGS'
}
const state = {
  clientNotes: [],
  options: {},
  settings: {}
}

const mutations = {
  [types.ADD_CLIENT_NOTES]: function (state, clientNotes) {
    state.clientNotes = clientNotes
  },
  [types.ADD_CLIENT_NOTE_OPTIONS]: function (state, options) {
    state.options = options
  },
  [types.ADD_CLIENT_NOTE_SETTINGS]: function (state, settings) {
    state.settings = settings
  }
}

const actions = {
  getClientNoteData: async function ({ commit }, { clientId, filters }) {
    const params = { filters: JSON.stringify(filters) }
    const response = await httpService.get(`/client-note/${clientId}`, { params })
    if (!response) {
      commit(types.ADD_CLIENT_NOTES, [])
      commit(types.ADD_CLIENT_NOTE_SETTINGS, {})
      commit(types.ADD_CLIENT_NOTE_OPTIONS, {})
      return []
    }

    commit(types.ADD_CLIENT_NOTES, response.data.data)
    commit(types.ADD_CLIENT_NOTE_SETTINGS, response.data.settings)
    commit(types.ADD_CLIENT_NOTE_OPTIONS, response.data.options)
    return response.data
  },
  createClientNote: function ({ commit }, { clientId, clientNote }) {
    clientNote = {
      name: clientNote.name,
      content: clientNote.content,
      category_id: clientNote.category_id
    }
    return httpService.post(`/client-note/${clientId}`, clientNote,
      { successMessage: 'Project Note successfully created', raiseError: true, cancelErrorMessage: true })
  },
  deleteClientNoteById: function ({ commit }, { clientId, clientNoteId }) {
    const config = {
      params: {
        id: clientNoteId
      },
      successMessage: 'Project Note successfully deleted',
      raiseError: true,
      cancelErrorMessage: true
    }
    return httpService.delete(`/client-note/${clientId}`, config)
  },
  updateClientNote: function ({ commit }, { clientId, clientNote }) {
    clientNote = {
      id: clientNote.id,
      name: clientNote.name,
      content: clientNote.content,
      category_id: clientNote.category_id
    }
    return httpService.patch(`/client-note/${clientId}`, clientNote,
      { successMessage: 'Project Note successfully updated', raiseError: true, cancelErrorMessage: true })
  },
  // getClientNoteSettings: async function ({ commit, dispatch }) {
  //   const response = await httpService.get('/client-note/settings')
  //   if (!response || !response.data) {
  //     commit(types.ADD_CLIENT_NOTE_SETTINGS, {})
  //     return {}
  //   }
  //
  //   commit(types.ADD_CLIENT_NOTE_SETTINGS, response.data)
  //   return response.data
  // },
  // getClientNoteOptions: async function ({ commit }) {
  //   const response = await httpService.get('/client-note/options')
  //   if (!response) {
  //     commit(types.ADD_CLIENT_NOTE_OPTIONS, {})
  //     return {}
  //   }
  //
  //   commit(types.ADD_CLIENT_NOTE_OPTIONS, response.data)
  //   return response.data
  // }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
